import { __AppElementType } from "../common/Dictionaries";
import { 
	SET_BOARD_SCOPE_VALUES
} from "./actions/KPI/actions";

const initialState = {
	_boardScopeValues: null,
};
const boardScopeReducer = (state = initialState, action) => {
	switch (action.type) {
		case  SET_BOARD_SCOPE_VALUES:		
			return {
				...state,
				_boardScopeValues: action.payload.objectList
			};

		default:
			return state;
	}
};

export default boardScopeReducer;